import {
  configure,
  hitsPerPage,
  index,
} from "instantsearch.js/es/widgets/index.js";
import { filterAssignments } from "./facets.js"; // Import facets and filterAssignments
import {
  chamfrColumnConfigMiddleware,
  chamfrOutOfStockMiddleware,
  chamfrLoadingSkeletonMiddleware,
} from "./middleware/index.js";
import {
  chamfrClearAllFilters,
  chamfrPagination,
  chamfrProductsHits,
  chamfrProductsSortBy,
  chamfrResultsHeader,
  chamfrSearchBox,
  chamfrSelectedFilters,
} from "./widgets/index.js";
import {
  createCustomLabels,
  createNewSearchInstance,
  createTableColumns,
  renderFilters,
} from "./components/index.js";

export const initializeProductCategory = (productCategoryElement) => {
  const { categoryName, categorySlug } = productCategoryElement.dataset;
  const categorySetup =
    filterAssignments[categorySlug] ?? filterAssignments["DEFAULT"];

  const columns = [
    ...categorySetup.displayHits,
    ...filterAssignments["EVERY"].displayHits,
  ].sort((a, b) => a.orderColumns - b.orderColumns);

  const filters = [
    ...categorySetup.displayFacets,
    ...filterAssignments["EVERY"].displayFacets,
  ].sort((a, b) => a.orderFacets - b.orderFacets);

  const search = createNewSearchInstance();
  search.use(chamfrOutOfStockMiddleware);
  search.use(chamfrLoadingSkeletonMiddleware);
  search.use(chamfrColumnConfigMiddleware({ formatNumbers: true }));

  const defaultSortBy = categorySetup.sorting?.orderby;
  const defaultSortOrder = categorySetup.sorting?.order;

  const defaultIndex = defaultSortBy
    ? `${algolia.product_index_name}_${defaultSortBy}_${defaultSortOrder}`
    : algolia.product_index_name;

  const products = index({
    indexName: defaultIndex,
    indexId: "products",
  });

  const widgets = [
    configure({
      getRankingInfo: true,
      clickAnalytics: true,
      filters: `category:"${categoryName}"`,
      index: defaultIndex,
    }),
    chamfrSearchBox({
      container: productCategoryElement.querySelector(".search-form"),
      label: "Search within these results",
    }),
    chamfrResultsHeader({
      container: productCategoryElement.querySelector(".results-header"),
    }),
    hitsPerPage({
      container: productCategoryElement.querySelector(".display-per-page span"),
      items: [
        { label: "50 Items", value: 50, default: true },
        { label: "100 Items", value: 100 },
        { label: "250 Items", value: 250 },
      ],
    }),
    chamfrPagination({
      container: productCategoryElement.querySelector(".chamfr-pagination"),
    }),
    chamfrClearAllFilters({
      container: productCategoryElement.querySelector(
        ".selected-filters .clear-all-filters"
      ),
    }),
  ];

  const filtersContainer = productCategoryElement.querySelector(
    ".search-results-leftside"
  );

  const customLabels = createCustomLabels(filters);
  const tableColumns = createTableColumns(columns, { formatNumbers: true });

  widgets.push(
    ...renderFilters(filters, filtersContainer, productCategoryElement)
  );

  widgets.push(
    chamfrSelectedFilters({
      container: productCategoryElement.querySelector(".selected-filters ul"),
      customLabels: Object.fromEntries(customLabels),
    })
  );

  widgets.push(
    chamfrProductsSortBy({
      container: productCategoryElement.querySelector("table.products .header"),
      items: [],
      defaultIndex: defaultIndex,
      columns: tableColumns,
    })
  );

  widgets.push(
    chamfrProductsHits({
      container: productCategoryElement.querySelector("table.products .list"),
      columns: tableColumns,
    })
  );

  products.addWidgets(widgets);

  search.addWidgets([products]);

  search.start();
};
